export const BUBBLE_SIZE_PX = 52;
export const EDGE_MARGIN_PX = 24;
export const DRAG_THRESHOLD_PX = 5;
export const SNAP_ANIMATION_DURATION_MS = 400;
export const CONTAINER_MIDPOINT_DIVISOR = 2;
